import I18n from 'i18n-js';
import Rails from '@rails/ujs';
import TaskAssignation from '../utils/TaskAssignation';
import ActionAssignation from '../utils/ActionAssignation';
import TelesoftSyncChargeManager from './TelesoftSyncChargeManager.js';
import OrderSyncManager from './OrderSyncManager.js';
import { getHtmlFromAjaxResponse } from '../utils/ajaxResponseHelpers';
import EconomicModelFormHandler from '../utils/EconomicModelFormHandler';
import VtCalendarManager from '../utils/VtCalendarManager';
import MoeOverviewManager from '../utils/MoeOverviewManager';
import ChatPanel from '../../common/utils/ChatPanel';

export default class BackofficeTasksShow {
  constructor() {
    this.orderSync = new OrderSyncManager();
    this.autoStartUnitOrderSync = false;
    this.pendingTelesoftAfterUnitSync = false;
    this.bindEvents();
    this.initDropify();
    this.taskAssignation = new TaskAssignation();
    this.telesoftSyncChargeManager = new TelesoftSyncChargeManager();
    this.chatPanel = new ChatPanel({
      tabs: true,
      visibilityCallback: (checked, itemType, attachmentId, url) => {
        this.changeItemVisibilityFromChat(checked, itemType, attachmentId, url);
      }
    });
    this.setupSendToMoeModal();
    this.setupPvmadModal();
    this.setupWaitingPeriodsModal();
    this.setupActivityHistoryModal();
    // this.setupOrderEditModal();
    this.initSyncOrdersModal();
    EconomicModelFormHandler.setup();
    this.checkForAutoSyncModalsTrigger();
    this.vtCalendarManager = new VtCalendarManager();
    this.moeOverviewManager = new MoeOverviewManager();
    this.registerTurbolinksCleanup();
  }

  checkForAutoSyncModalsTrigger() {
    const urlParams = new URLSearchParams(window.location.search);
    const showUnitSyncModal = urlParams.get('show_unit_sync_modal') === 'true';
    const showTelesoftModal = urlParams.get('show_telesoft_modal');

    if (!showUnitSyncModal && showTelesoftModal !== 'true') {
      return;
    }

    if (showUnitSyncModal) {
      urlParams.delete('show_unit_sync_modal');
    }
    if (showTelesoftModal === 'true') {
      urlParams.delete('show_telesoft_modal');
    }

    const newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '');
    window.history.replaceState({}, '', newUrl);

    if (showUnitSyncModal) {
      this.triggerUnitOrderSyncModal(showTelesoftModal === 'true');
      return;
    }

    if (showTelesoftModal === 'true') {
      this.triggerTelesoftModal();
    }
  }

  triggerUnitOrderSyncModal(showTelesoftAfter = false) {
    const $modal = $('#syncOrdersModal');
    if (!$modal.length) {
      if (showTelesoftAfter) {
        this.triggerTelesoftModal();
      }
      return;
    }

    this.autoStartUnitOrderSync = true;
    this.pendingTelesoftAfterUnitSync = showTelesoftAfter;
    $modal.modal('show');
  }

  triggerTelesoftModal() {
    const orderId = this.getOrderIdFromPage();
    if (orderId) {
      setTimeout(() => {
        this.telesoftSyncChargeManager.initializeModal(orderId);
      }, 500);
    }
  }

  bindEvents() {
    if (this.actionAssignation) {
      this.actionAssignation.onDestroy();
    }

    this.actionAssignation = new ActionAssignation();

    const sp = new URLSearchParams(window.location.search).get('sp');
    if (sp) {
      $(window).scrollTop(sp);
    }

    $(".show-comments").on('click', this.showComments);
    $(".show-files").on('click', this.showFiles);

    $(".comment-visibility-checkbox").on('change', (e) => this.changeItemVisibility(e));

    $(".show-file-btn").on('click', this.showFileModal);

    $(".move-forward").on('click', (e) => {
      this.handleStateUpdate($(e.currentTarget), 'bg-success text-white', 'bg-warning text-white', ".next-step-alert", ".previous-step-alert", 'url-forward');
    });

    $(".move-backward").on('click', (e) => {
      this.handleStateUpdate($(e.currentTarget), 'bg-warning text-white', 'bg-success text-white', ".previous-step-alert", ".next-step-alert", 'url-backward');
    });

    $(".original").on('click', (e) => {
      const $li = $(e.currentTarget);
      $li.addClass('bg-info text-white').removeClass('bg-soft-success bg-soft-warning')
         .siblings(".aside").removeClass('bg-warning bg-success text-white');
      
      $(".next-step-alert").addClass("d-none");
      $(".previous-step-alert").addClass("d-none");

      const $updateBtn = $(".update-process-btn");
      this.updateButtonState($updateBtn, "#", true);
    });

    $(".owners-select").each(function() {
      const $select = $(this);
      if ($select.data('select2')) {
        $select.select2('destroy');
      }

      $select.select2({
        placeholder: "Choisir un ou plusieurs propriétaires",
        allowClear: true,
        closeOnSelect: false,
        multiple: true
      });
    });

    $(".select2-project").each(function() {
      const $select = $(this);
      if ($select.data('select2')) {
        $select.select2('destroy');
      }

      $select.select2({
          placeholder: "Sélectionner un projet",
          allowClear: true,
          language: {
            noResults: function() {
              return "Aucun résultat trouvé";
            }
          }
        }).on('change', function() {
          this.form.requestSubmit();
        });
    });

    this.updateActionTime(".started-at-field", "started_at", "backoffice.actions.update_started_at_success", "backoffice.actions.update_started_at_error");
    this.updateActionTime(".ended-at-field", "ended_at", "backoffice.actions.update_ended_at_success", "backoffice.actions.update_ended_at_error");

    $(".status-select").off('change').on('change', this.bindStatusChange);

    this.bindStatusChange();
    this.bindCommentButton();
    this.bindCommentSubmit();
    this.setupMoeSelectionGuard();

    $(".custom-field-submit").on('click', function() {
      const field_id = $(this).data('field-id');      
      const field = $(`#${field_id}`);

      const url = $(field).data('url');

      if (field[0].checkValidity() === false) {
        field.addClass('is-invalid');
        $(`#${field_id}_validation`).removeClass('text-muted').addClass('text-danger').text(field[0].validationMessage);
        return;
      }

      Rails.ajax({
        url: url,
        type: 'PUT',
        data: `value=${encodeURIComponent(field.val())}`,
        success: function(data) {
          $(`#${field_id}_validation`).removeClass('text-danger').addClass('text-muted').text('');
          field.removeClass('is-invalid');
          application.successNotification(I18n.t('backoffice.tasks.custom_field_updated'));
        },
        error: function(data) {
          application.errorNotification(I18n.t('backoffice.tasks.custom_field_update_error'));
        }
      });
    });

    // Handle collapsible rows
    $('.clickable-row').on('click', function() {
      const icon = $(this).find('.collapse-icon');
      const isExpanded = $($(this).data('target')).hasClass('show');
      
      if (isExpanded) {
          icon.removeClass('fa-chevron-up').addClass('fa-chevron-down');
      } else {
          icon.removeClass('fa-chevron-down').addClass('fa-chevron-up');
      }
    });

    // Initialize collapsible rows
    $('#collapseCustomFields').on('shown.bs.collapse', function() {
        const icon = $('[data-target="#collapseCustomFields"]').find('.collapse-icon');
        icon.removeClass('fa-chevron-down').addClass('fa-chevron-up');
    });

    $('#collapseCustomFields').on('hidden.bs.collapse', function() {
        const icon = $('[data-target="#collapseCustomFields"]').find('.collapse-icon');
        icon.removeClass('fa-chevron-up').addClass('fa-chevron-down');
    });
  }

  handleStateUpdate($li, addClass, removeClass, alertToShow, alertToHide, urlData) {
    $li.addClass(addClass).siblings(".aside").removeClass(removeClass);
    
    const $ogLi = $li.siblings(".original");
    $ogLi.removeClass('bg-info text-white bg-soft-warning bg-soft-success').addClass(addClass.replace('bg-', 'bg-soft-'));
  
    $(alertToHide).addClass("d-none");
    $(alertToShow).removeClass("d-none");
  
    const $updateBtn = $(".update-process-btn");
    
    if ($li.data('step') == 1) {
      this.updateButtonState($updateBtn, "#", true);

      $updateBtn.off('click').on('click', (event) => {
        event.preventDefault();
        $('#order-edit').modal('show');
        $('#order-process').modal('hide');
      }).removeClass('disabled').removeAttr('data-method');
    } else {
      this.handleNonFirstStepTransition($updateBtn, urlData);
    }
  }

  handleNonFirstStepTransition($updateBtn, urlData) {
    const currentStep = Number.parseInt($('.original').data('step'));
    const isForwardMove = urlData === 'url-forward';
    const orderId = this.getOrderIdFromPage();
    const orderDataElement = $('#order-data');
    const isFonLoc = orderDataElement.length && orderDataElement.data('is-fon-loc') === true;
    
    // For FON/LOC orders moving to billing setup (step 5), skip Telesoft modal and just transition
    if (isForwardMove && currentStep === 4 && isFonLoc) {
      // FON/LOC orders: skip Telesoft sync, charge was already created at validation
      this.applyNormalStepTransition($updateBtn, urlData);
    } else if (isForwardMove && currentStep === 4) {
      // Non-FON/LOC orders: show Telesoft modal
      this.handleTelesoftTransition($updateBtn, urlData);
    } else {
      this.applyNormalStepTransition($updateBtn, urlData);
    }
  }

  handleTelesoftTransition($updateBtn, urlData) {
    const orderId = this.getOrderIdFromPage();
    const telesoftChargeExists = this.checkTelesoftChargeExists();
    
    if (telesoftChargeExists) {
      this.applyNormalStepTransition($updateBtn, urlData);
    } else {
      this.updateButtonState($updateBtn, "#", false);
      
      $updateBtn.off('click').on('click', (event) => {
        event.preventDefault();
        $('#order-process').modal('hide');
        
        if (orderId) {
          this.telesoftSyncChargeManager.initializeModal(orderId);
        } else {
          console.error('Could not find order ID for TeleSoft sync');
          alert('Erreur: Impossible de démarrer la synchronisation TeleSoft');
        }
      }).removeClass('disabled').removeAttr('data-method');
    }
  }

  applyNormalStepTransition($updateBtn, urlData) {
    this.updateButtonState($updateBtn, $updateBtn.data(urlData));
    if (!$updateBtn.attr('data-method')) {
      $updateBtn.attr('data-method', 'put');
    }
    $updateBtn.off('click');
  }

  checkTelesoftChargeExists() {
    // First check the hidden order-data element for charge status
    const orderDataElement = $('#order-data');
    if (orderDataElement.length) {
      return orderDataElement.data('telesoft-charge-created') === true;
    }
    
    // Fallback: Check if the TeleSoft charge modal exists - if it doesn't, the charge already exists
    const orderId = this.getOrderIdFromPage();
    if (orderId) {
      return $(`#telesoft-sync-charge-modal-${orderId}`).length === 0;
    }
    
    // Alternative check: look for indicators in the page that charge exists
    return $('[data-telesoft-charge-created="true"]').length > 0;
  }

  getOrderIdFromPage() {
    // First, try to get order ID from the hidden order-data element
    const orderDataElement = $('#order-data');
    if (orderDataElement.length) {
      return orderDataElement.data('order-id');
    }
    
    // Fallback: try to get order ID from the TeleSoft sync charge modal if it exists
    const telesoftModal = $('[id^="telesoft-sync-charge-modal-"]').first();
    if (telesoftModal.length) {
      return telesoftModal.data('order-id');
    }
    
    // Try to get order ID from any element with data-order-id attribute
    const orderIdElement = $('[data-order-id]').first();
    if (orderIdElement.length) {
      return orderIdElement.data('order-id');
    }
    
    return null;
  }

  initSyncOrdersModal() {
    const $modal = $('#syncOrdersModal');
    if (!$modal.length) {
      return;
    }

    $modal.on('show.bs.modal', () => {
      this.resetSyncOrdersModal();
      this.populateSyncOrdersList();

      if (this.autoStartUnitOrderSync) {
        this.autoStartUnitOrderSync = false;
        setTimeout(() => {
          this.performSyncOrders();
        }, 200);
      }
    });

    $modal.on('hidden.bs.modal', () => {
      if (this.pendingTelesoftAfterUnitSync) {
        this.pendingTelesoftAfterUnitSync = false;
        this.triggerTelesoftModal();
      }
    });

    $('#sync-orders-confirm-btn').off('click.unitOrderSync').on('click.unitOrderSync', () => {
      this.performSyncOrders();
    });
  }

  resetSyncOrdersModal() {
    $('#sync-orders-initial').show();
    $('#sync-orders-processing').hide();
    $('#sync-orders-success').hide();
    $('#sync-orders-error').hide();
    $('#sync-orders-confirm-btn').show().prop('disabled', false);
    $('#sync-orders-cancel-btn').show();
    $('#sync-orders-close-btn').hide();
  }

  populateSyncOrdersList() {
    const $list = $('#sync-orders-list');
    $list.empty();

    const orderDataElement = $('#order-data');
    const serviceNumber = orderDataElement.data('service-number');
    const orderId = this.getOrderIdFromPage();

    if (serviceNumber) {
      $list.append(`<li>${serviceNumber}</li>`);
    } else if (orderId) {
      $list.append(`<li>#${orderId}</li>`);
    }
  }

  performSyncOrders() {
    const $modal = $('#syncOrdersModal');
    const syncUrl = $modal.data('sync-orders-url');
    const orderId = this.getOrderIdFromPage();

    if (!syncUrl || !orderId) {
      $('#sync-orders-error').show();
      $('#sync-orders-error-message').text('Impossible de démarrer la synchronisation UniT.');
      this.showSyncOrdersCloseButtons();
      return;
    }

    const orderIds = [orderId];

    $('#sync-orders-initial').hide();
    $('#sync-orders-error').hide();
    $('#sync-orders-processing').show();
    $('#sync-orders-confirm-btn').prop('disabled', true);
    $('#sync-orders-cancel-btn').hide();

    this.orderSync.syncOrders(syncUrl, orderIds)
      .done((data) => {
        $('#sync-orders-processing').hide();

        if (data.success) {
          $('#sync-orders-success').show();
          $('#sync-orders-success-message').text(data.message || 'Synchronisation réussie.');
          this.updateOrderSyncBadge(orderId, true);
        } else {
          $('#sync-orders-error').show();
          $('#sync-orders-error-message').text(data.error || 'Erreur inconnue');
        }

        this.showSyncOrdersCloseButtons();
      })
      .fail((_xhr, _status, error) => {
        console.error('Error syncing orders:', error);
        $('#sync-orders-processing').hide();
        $('#sync-orders-error').show();
        $('#sync-orders-error-message').text('Erreur lors de la synchronisation des commandes.');
        this.showSyncOrdersCloseButtons();
      });
  }

  updateOrderSyncBadge(orderId, synced) {
    const $badge = $(`#order-sync-badge-${orderId}`);
    if (!$badge.length) {
      return;
    }

    if (synced) {
      $badge
        .removeClass('badge-danger')
        .addClass('badge-success')
        .html('<i class="mdi mdi-check mr-1"></i>Synchronisé UniT');

      $('#order-data').attr('data-unit-sync', 'true').data('unit-sync', true);
    }
  }

  showSyncOrdersCloseButtons() {
    $('#sync-orders-confirm-btn').hide();
    $('#sync-orders-cancel-btn').hide();
    $('#sync-orders-close-btn').show();
  }
  
  updateButtonState(updateBtn, url, disabled = false) {
      updateBtn.toggleClass('disabled', disabled);
      updateBtn.attr('href', url);
  }

  showComments() {
    $("#comments-section").removeClass("d-none").addClass("d-flex");
    $("#files-section").removeClass("d-flex").addClass("d-none");

    $(".show-comments").addClass("underline");
    $(".show-files").removeClass("underline")
  }

  showFiles() {
    $("#comments-section").removeClass("d-flex").addClass("d-none");
    $("#files-section").removeClass("d-none").addClass("d-flex");

    $(".show-comments").removeClass("underline")
    $(".show-files").addClass("underline")
  }

  showFileModal() {
    let title = $(this).data('file-title');
    let url = $(this).data('file-url');

    $("#file-modal-title").text(title);
    
    $("#embed-wrapper").empty();
    if (url.endsWith('.pdf')) {
      $("#embed-wrapper").append(`<embed src="${url}" type="application/pdf" width="100%" height="600px" />`);
    } else if (url.endsWith('.jpg') || url.endsWith('.jpeg') || url.endsWith('.png')) {
      $("#embed-wrapper").append(`<img src="${url}" class="img-fluid" />`);
    } else {
      $("#embed-wrapper").append(`<iframe src="${url}" width="100%" height="600px" />`);
    }

    $("#download-button").attr('href', url);
    $("#file-modal").modal('show'); 
  }

  changeItemVisibility(e) {
    const $this = $(e.currentTarget);
    const attachment_id = $this.data('attachment-id');
    const item_type = $this.data('item-type');
    const visibility = $this.is(':checked');
    const url = $this.data('url');

    Rails.ajax({
      url: url,
      type: 'PUT',
      data: `item[visibility]=${visibility}&item[item_type]=${encodeURIComponent(item_type)}&item[id]=${attachment_id}`,
      success: function(data) {
        application.successNotification(I18n.t("backoffice.tasks.update_visibility_success"))
      },
      error: function(data) {
        application.errorNotification(I18n.t('backoffice.tasks.update_visibility_error'));
      }
    });
  }

  changeItemVisibilityFromChat(checked, itemType, attachmentId, url) {
    Rails.ajax({
      url: url,
      type: 'PUT',
      data: `item[visibility]=${checked}&item[item_type]=${encodeURIComponent(itemType)}&item[id]=${attachmentId}`,
      success: function() {
        application.successNotification(I18n.t("backoffice.tasks.update_visibility_success"));
      },
      error: function() {
        application.errorNotification(I18n.t('backoffice.tasks.update_visibility_error'));
      }
    });
  }

  initDropify(context = document) {
    const $inputs = $(context).find('.dropify').filter(function() {
      return !$(this).data('dropify');
    });

    if (!$inputs.length) {
      return;
    }

    $inputs.dropify({
      messages: {
      'default': I18n.t('plugins.dropify.messages.default'),
      'replace': I18n.t('plugins.dropify.messages.replace'),
      'remove': I18n.t('plugins.dropify.messages.remove'),
      'error': I18n.t('plugins.dropify.messages.error')
      },
      error: {
      'fileSize': I18n.t('plugins.dropify.error.fileSize', { value: '2MB' }),
      'minWidth': I18n.t('plugins.dropify.error.minWidth'),
      'maxWidth': I18n.t('plugins.dropify.error.maxWidth'),
      'minHeight': I18n.t('plugins.dropify.error.minHeight'),
      'maxHeight': I18n.t('plugins.dropify.error.maxHeight'),
      'imageFormat': I18n.t('plugins.dropify.error.imageFormat'),
      'fileExtension': I18n.t('plugins.dropify.error.fileExtension'),
    }
    });
  }

  setupSendToMoeModal() {
    const modal = $('#sendOrderToMoeModal');

    if (!modal.length) {
      return;
    }

    const attachmentsContainer = modal.find('[data-attachments-container]');
    const addAttachmentButton = modal.find('[data-add-attachment]');
    const recipientSelect = modal.find('.js-moe-recipient-select');

    if (recipientSelect.length && !recipientSelect.data('select2')) {
      recipientSelect.select2({
        placeholder: recipientSelect.data('placeholder'),
        dropdownParent: modal,
        width: '100%'
      });
    }

    addAttachmentButton.on('click', (event) => {
      event.preventDefault();

      const attachmentField = $('<div>', { class: 'moe-attachment-field mb-2' }).append(
        $('<input>', {
          type: 'file',
          name: 'send_to_moe[attachments][]',
          class: 'form-control dropify',
          'data-max-file-size': '10M',
          'data-allowed-file-extensions': 'pdf doc docx xls xlsx ppt pptx jpg jpeg png zip'
        })
      );

      attachmentsContainer.append(attachmentField);
      this.initDropify(attachmentField);
    });

    modal.on('hidden.bs.modal', () => {
      attachmentsContainer.find('.moe-attachment-field').slice(1).each(function() {
        const instance = $(this).find('input[type=file]').data('dropify');
        if (instance) {
          instance.destroy();
        }
        $(this).remove();
      });

      attachmentsContainer.find('.moe-attachment-field').first().find('input[type=file]').each(function() {
        const dropifyInstance = $(this).data('dropify');
        if (dropifyInstance) {
          dropifyInstance.resetPreview();
          dropifyInstance.clearElement();
        }
      });

      modal.find('[data-default-value]').each(function() {
        const $field = $(this);
        const defaultValue = $field.data('default-value');
        if (defaultValue !== undefined) {
          $field.val(defaultValue);
          if ($field.is('select')) {
            $field.trigger('change');
          }
        }
      });
    });
  }

  setupPvmadModal() {
    const modal = $('#generatePvmadModal');

    if (!modal.length) {
      return;
    }

    const form = modal.find('#generate-pvmad-form');
    const submitButton = modal.find('[data-submit-pvmad]');
    const originalButtonHtml = submitButton.html();

    modal.on('hidden.bs.modal', () => {
      submitButton.prop('disabled', false).html(originalButtonHtml);
    });
  }

  // setupOrderEditModal() {
  //   const modal = $('#order-edit');
  //
  //   if (!modal.length) {
  //     return;
  //   }
  //
  //   const deadlineDaysInput = modal.find('#deadline-days-input');
  //   const deadlinePreview = modal.find('#deadline-preview');
  //   const calculateDeadlineUrl = modal.data('calculate-deadline-url');
  //
  //   if (!deadlineDaysInput.length || !calculateDeadlineUrl) {
  //     return;
  //   }
  //
  //   // Store debounce timer
  //   let debounceTimer = null;
  //
  //   const updateDeadlinePreview = (days) => {
  //     // Clear existing timer
  //     if (debounceTimer) {
  //       clearTimeout(debounceTimer);
  //     }
  //
  //     // Debounce to avoid too many requests
  //     debounceTimer = setTimeout(() => {
  //       // Show loading state
  //       deadlinePreview.html('<i class="fas fa-spinner fa-spin"></i>');
  //
  //       const url = `${calculateDeadlineUrl}?days=${days}`;
  //
  //       Rails.ajax({
  //         url: url,
  //         type: 'GET',
  //         dataType: 'json',
  //         success: (response) => {
  //           if (response && response.deadline) {
  //             deadlinePreview.text(response.deadline);
  //           } else {
  //             deadlinePreview.text('--');
  //           }
  //         },
  //         error: () => {
  //           deadlinePreview.text('--');
  //         }
  //       });
  //     }, 300);
  //   };
  //
  //   // Bind input change event
  //   deadlineDaysInput.on('input change', function() {
  //     const days = Number.parseInt($(this).val(), 10);
  //     if (days && days >= 1 && days <= 365) {
  //       updateDeadlinePreview(days);
  //     }
  //   });
  //
  //   // Reset to default when modal is opened
  //   modal.on('show.bs.modal', () => {
  //     const defaultDays = deadlineDaysInput.data('default_deadline_days');
  //     if (defaultDays) {
  //       deadlineDaysInput.val(defaultDays);
  //       // Don't trigger update, the server-rendered default is already shown
  //     }
  //   });
  // }

  setupActivityHistoryModal() {
    const modal = $('#activityHistoryModal');

    if (!modal.length) {
      return;
    }

    $('.activity-history-btn').on('click', (e) => {
      const url = $(e.currentTarget).data('url');

      $('#activityHistoryModalBody').html(`
        <div class="text-center py-4">
          <i class="fas fa-spinner fa-spin fa-2x"></i>
          <p class="mt-2">Chargement...</p>
        </div>
      `);

      $.ajax({
        url: url,
        method: 'GET',
        success: (data) => {
          $('#activityHistoryModalBody').html(data);
          this.initActivityHistoryDataTable();
        },
        error: () => {
          $('#activityHistoryModalBody').html(`
            <div class="text-center text-danger py-4">
              <i class="fas fa-exclamation-triangle fa-2x mb-2"></i>
              <p>Erreur lors du chargement de l'historique.</p>
            </div>
          `);
        }
      });
    });

    modal.on('hidden.bs.modal', () => {
      if (this.activityHistoryDataTable) {
        this.activityHistoryDataTable.destroy();
        this.activityHistoryDataTable = null;
      }
    });
  }

  initActivityHistoryDataTable() {
    const table = $('#activity-history-table');
    
    if (!table.length) {
      return;
    }

    this.activityHistoryDataTable = table.DataTable({
      pageLength: 10,
      order: [[3, 'desc']],
      language: require('../utils/plugins/datatables_translation/' + I18n.locale + '.json'),
      dom: '<"row"<"col-sm-12 col-md-6"f><"col-sm-12 col-md-6"l>>rtip'
    });
  }

  // Disable MOE send button when MOE selection changes to avoid sending to wrong MOE
  setupMoeSelectionGuard() {
    const moeSelect = $('select[name="moe_id"]');

    if (!moeSelect.length) {
      return;
    }

    moeSelect.off('change.disableSendToMoe').on('change.disableSendToMoe', () => {
      const sendButton = $('.send-order-to-moe-btn');
      if (!sendButton.length) {
        return;
      }

      sendButton.prop('disabled', true).addClass('disabled').attr('aria-disabled', 'true');
    });
  }

  setupWaitingPeriodsModal() {
    const modal = $('#waitingPeriodsModal');
    if (!modal.length) return;

    modal.on('show.bs.modal', () => {
      this.loadWaitingPeriods();
    });
  }

  loadWaitingPeriods() {
    const modal = $('#waitingPeriodsModal');
    const container = $('#waiting-periods-content');
    const url = modal.data('url');

    if (!url) return;

    Rails.ajax({
      url: url,
      type: 'GET',
      success: (response, _status, xhr) => {
        container.html(getHtmlFromAjaxResponse(response, xhr));
        this.bindWaitingPeriodsEvents();
      }
    });
  }

  bindWaitingPeriodsEvents() {
    $('.edit-waiting-period-btn').off('click').on('click', (e) => {
      const periodId = $(e.currentTarget).data('period-id');
      const editRow = $(`tr[data-edit-for="${periodId}"]`);

      $('.edit-row').addClass('d-none');

      if (editRow.length) {
        editRow.removeClass('d-none');
      }
    });

    $('.cancel-edit-btn').off('click').on('click', (e) => {
      const periodId = $(e.currentTarget).data('period-id');
      const editRow = $(`tr[data-edit-for="${periodId}"]`);
      if (editRow.length) {
        editRow.addClass('d-none');
      }
    });
  }

  updateActionTime(fieldClass, timeKey, successMessage, errorMessage) {
    $(fieldClass).on('change', function() {
      const $this = $(this); 
      if ($this.data('processing')) return; 

      $this.data('processing', true);
      
      const timeValue = $this.val();
      const url = $this.data('url');

      const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
      const minDate = new Date('2024-01-01');

      if (dateRegex.test(timeValue)) {
        const inputDate = new Date(timeValue);
        if (inputDate > minDate) {
          Rails.ajax({
            url: url,
            type: 'PUT',
            data: `task[${timeKey}]=${encodeURIComponent(timeValue)}`,
            success: function(response) {
              application.successNotification(I18n.t(successMessage));

              // $(`#action-${response.action_id}-deadline`).html(response.deadline);
              // const element = $(`.ended-at-field-${response.action_id}`);
              //
              // if (response.is_late) {
              //   element.addClass('is-late');
              // } else {
              //   element.removeClass('is-late');
              // }
            },
            error: function() {
              application.errorNotification(I18n.t(errorMessage));
            },
            complete: function() {
              setTimeout(() => $this.data('processing', false), 500);
            }
          });
        }
      } else {
        $this.data('processing', false);
      }
    });
  }

  bindStatusChange() {
    $(".status-select").on('change', (e) => {
      const selectObj = $(e.currentTarget);
      const status = selectObj.val();
      const url = selectObj.data('url');
  
      Rails.ajax({
        url: url,
        type: 'PUT',
        data: `status=${encodeURIComponent(status)}&sp=${$(window).scrollTop()}`,
        dataType: 'json',
        success: (response) => {
          $("#steps-wrapper").html(response.steps);
          
          if (response.details_widget) {
            const $detailsContainer = $("#details-widget-container");
            if ($detailsContainer.length) {
              $detailsContainer.html(response.details_widget);
              this.reinitializeDetailsWidget();
            }
          }
          
          this.bindEvents();
        },
        error: () => {
          application.errorNotification(I18n.t('backoffice.tasks.update_status_error'));
        }
      });
    });
  }

  reinitializeDetailsWidget() {
    if (this.taskAssignation) {
      this.taskAssignation.onDestroy();
      this.taskAssignation = new TaskAssignation();
    }
    
    $('[data-toggle="modal"]').off('click');
    
    $('[data-toggle="tooltip"]').tooltip();
    
    $('.select2').each(function() {
      if (!$(this).data('select2')) {
        $(this).select2();
      }
    });
  }

  bindCommentSubmit() {
    $(".action-comment-submit").off('click');
    $(".action-comment-submit").on('click', (e) => {
      const form = $(e.currentTarget).closest('form')[0];
      const url = $(form).attr('action');
      const formData = new FormData(form);
  
      Rails.ajax({
        url: url,
        type: 'POST',
        data: formData,
        processData: false,
        success: (response) => {
          $(".action-comments-modal-body").html(response.content);
          application.successNotification(I18n.t('backoffice.tasks.comments.comment_added'));
          
          const action_id = response.action_id;

          const commentCounter = $(`#comments-count-action-${action_id}`);
          
          if (response.comments_count) {
            commentCounter.text(response.comments_count);
          }

          this.initDropify(); 
          this.bindCommentSubmit();
          this.bindActionCommentsScrollToTop();

          $("#actionComments").modal('hide');
        },
        error: (response) => {
          $(".action-comments-modal-body").html(response.content);
          application.errorNotification(I18n.t('backoffice.tasks.comments.comment_not_added'));

          this.initDropify(); 
          this.bindCommentSubmit();
          this.bindActionCommentsScrollToTop();
        }
      });
    });
  }
  
  bindCommentButton() {
    $(".action-comments-btn").on('click', (e) => {
      const url = $(e.currentTarget).data('url');
  
      Rails.ajax({
        url: url,
        type: 'GET',
        success: (response, _status, xhr) => {
          $(".action-comments-modal-body").html(getHtmlFromAjaxResponse(response, xhr));
         
          $('.action-comments-wrapper').scrollTop($('.action-comments-wrapper')[0].scrollHeight);

          $("#actionComments").modal('show');
          this.initDropify(); 
          this.bindCommentSubmit();
          
          $("#actionComments").on('shown.bs.modal', () => {
            this.bindActionCommentsScrollToTop();
          });
        }
      });
    });
  }

  bindActionCommentsScrollToTop() {
      const commentsWrapper = $('.action-comments-wrapper');
      const scrollToTopBtn = $('#scroll-to-top-btn');
  
      // Function to update the visibility of the scroll-to-top button
      function updateScrollToTopBtnVisibility() {
          if (commentsWrapper.scrollTop() === 0) {
              scrollToTopBtn.hide();
          } else {
              scrollToTopBtn.show();
          }
      }
  
      // Initial check
      updateScrollToTopBtnVisibility();
  
      // Add scroll event listener to commentsWrapper
      commentsWrapper.on('scroll', updateScrollToTopBtnVisibility);
  
      // Add click event listener to scrollToTopBtn
      scrollToTopBtn.on('click', function() {
          commentsWrapper.animate({ scrollTop: 0 }, 'slow');
      });
  }

  setupOrderEditInvoiceStep() {
    const $modal = $('#order-edit');
    if (!$modal.length) return;

    const $nextBtn = $('#order-edit-next-btn');
    if (!$nextBtn.length) return; // FON/LOC orders don't have this button

    const $step1 = $('#order-edit-step1');
    const $step2 = $('#order-edit-invoice-step');
    const $invoiceNowField = $('#order-edit-invoice-now-field');
    const $form = $modal.find('form');

    $nextBtn.on('click', () => {
      $step1.hide();
      $step2.removeClass('d-none');
    });

    $('#order-edit-invoice-back-btn').on('click', () => {
      $step2.addClass('d-none');
      $step1.show();
    });

    $('#order-edit-invoice-now-btn').on('click', () => {
      $invoiceNowField.val('1');
      $form[0].requestSubmit();
    });

    $('#order-edit-invoice-later-btn').on('click', () => {
      $invoiceNowField.val('0');
      $form[0].requestSubmit();
    });

    $modal.on('hidden.bs.modal', () => {
      $step2.addClass('d-none');
      $step1.show();
      $invoiceNowField.val('');
    });
  }

  setupStudyRequestConfirmationModal() {
    EconomicModelFormHandler.setup();
  }

  onDataChanged(data) {
  }

  onDestroy() {
    $(".dropify").dropify("destroy");
    $(".select2").select2("destroy");
    $(".select2-project").select2("destroy");
    $('#syncOrdersModal').off('show.bs.modal');
    $('#syncOrdersModal').off('hidden.bs.modal');
    $('#sync-orders-confirm-btn').off('click.unitOrderSync');
    if (this.vtCalendarManager) {
      this.vtCalendarManager.destroy();
    }
    if (this.moeOverviewManager) {
      this.moeOverviewManager.destroy();
    }
  }

  registerTurbolinksCleanup() {
    const cleanup = () => {
      $(".owners-select").each(function() {
        const $select = $(this);
        if ($select.data('select2')) {
          $select.select2('destroy');
        }
      });

      $(".select2-project").each(function() {
        const $select = $(this);
        if ($select.data('select2')) {
          $select.select2('destroy');
        }
      });
    };

    document.removeEventListener('turbolinks:before-cache', cleanup);
    document.addEventListener('turbolinks:before-cache', cleanup);
  }
}